import React, { useState, useEffect, useContext } from "react";
import CustomFilters from "../../../../core/custom-filters";
import { Box, TextField } from "@mui/material";
import { HTTP_METHODS, plainApi } from "../../../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../../../utils/endpoints";
import SiAutocomplete from "../../../../core/si-autocomplete";
import SiTextField from "../../../../core/si-textfield";
import { checkForUserLimit, PAGE_LIMIT } from "../../../../utils";
import { USER_LIMITS } from "../../../../utils/constants";
import AppContext from "../../../../utils/context";
import { STATUS_LIST } from "./config";

const FailedEngineFilter = ({ loadData, setMainFilters, filter }) => {
  const [filterType, setFilterType] = useState("");
  const [filterValue, setFilterValue] = useState("");
  const [oemList, setOemList] = useState([]);
  const { userDetails = {} } = useContext(AppContext);
  let oemTimeout = null;

  const applyFilters = (filters) => {
    const defaultFilter = {};
    if (checkForUserLimit(USER_LIMITS.QUALITY_APPROVER, userDetails?.limits)) {
      defaultFilter["qualityApprover"] = userDetails?.id;
      defaultFilter["status"] = "PENDING";
    }
    if (Object.keys(filters).length) {
      const payload = {};
      for (let key in filters) {
        if (typeof filters[key] === "object" && filters[key]?.value) {
          payload[key] = filters[key].value;
        } else {
          payload[key] = filters[key];
        }
      }
      if (setMainFilters) {
        setMainFilters(payload);
      }
      loadData({
        ...payload,
        sortBy: "-createdAt",
        limit: PAGE_LIMIT,
        page: filter?.page || 1,
      });
    } else {
      if (setMainFilters) {
        setMainFilters({});
      }
      loadData({
        ...defaultFilter,
        sortBy: "-createdAt",
        limit: PAGE_LIMIT,
        page: 1,
      });
    }
  };
  const filterTypes = () => {
    const result = [
      { label: "Filter by Engine Model", value: "engineModel" },
      { label: "Filter by Serial Number", value: "engineSerialNumber" },
      { label: "Filter by List Number", value: "listNo" },
      { label: "Filter by Oem", value: "oem" },
    ];
    if (checkForUserLimit(USER_LIMITS.QUALITY_APPROVER, userDetails?.limits)) {
      result.push({
        label: "Filter by Status",
        value: "status",
      });
    }
    return result;
  };
  const handleRegexSearch = (newInputValue) => {
    clearTimeout(oemTimeout);
    if (newInputValue) {
      oemTimeout = setTimeout(() => getOemList(newInputValue), 300);
    }
  };
  const renderFilterInput = () => {
    switch (filterType) {
      case "engineModel":
        return (
          <SiTextField
            placeholder="Engine Model"
            name="engineModel"
            onChange={handleFilterValueChange}
          />
        );
      case "engineSerialNumber":
        return (
          <SiTextField
            placeholder="Engine Serial Number"
            name="engineSerialNumber"
            onChange={handleFilterValueChange}
          />
        );
      case "oem":
        return (
          <SiAutocomplete
            onChange={setFilterValue}
            options={oemList}
            placeholder="Search OEM"
          />
        );

      case "status":
        return (
          <SiAutocomplete
            onChange={setFilterValue}
            options={STATUS_LIST}
            placeholder="Search Status"
          />
        );
      case "listNo":
        return (
          <SiTextField
            placeholder="List Number"
            name="listNo"
            onChange={handleFilterValueChange}
          />
        );

      default:
        return null;
    }
  };
  const getOemList = (filters) => {
    plainApi(HTTP_METHODS.GET, `${HOSTNAME}${REST_URLS.OEM_NAMES}`, null, {
      ...filters,
    })
      .then((response) => {
        if (response) {
          const result = response.map((ele) => ({
            label: ele.name,
            value: ele.id,
          }));
          setOemList(result);
        }
      })
      .catch((err) => console.error(err));
  };

  useEffect(() => {
    if (filterType === "oem") {
      getOemList();
    }
  }, [filterType]);
  const handleFilterValueChange = (event) => {
    setFilterValue(event.target.value);
  };

  return (
    <div>
      <CustomFilters
        applyFilters={applyFilters}
        renderFilterInput={renderFilterInput}
        filterTypes={filterTypes()}
        filterType={filterType}
        setFilterType={setFilterType}
        filterValue={filterValue}
        setFilterValue={setFilterValue}
      />
    </div>
  );
};

export default FailedEngineFilter;
